"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _fecha = _interopRequireDefault(require("fecha"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PackageDetails = _interopRequireDefault(require("./PackageDetails"));

var _getOrganisationDisplayName = _interopRequireDefault(require("../../../utils/getOrganisationDisplayName"));

require("../styles/_organisation-details.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function getDate(date) {
  return _fecha.default.format(new Date(date), 'DD MMM YYYY');
}

function OrganisationDetails(_ref) {
  var organisation = _ref.organisation,
      smallContainer = _ref.smallContainer;
  var subPackage = organisation.package;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('organisation-details', {
      'organisation-details--small': smallContainer
    })
  }, _react.default.createElement("div", {
    className: "organisation-details__right-content"
  }, _react.default.createElement("p", {
    className: "organisation-details__right-content__title"
  }, _react.default.createElement("strong", null, (0, _getOrganisationDisplayName.default)(organisation))), _react.default.createElement(_PackageDetails.default, {
    subPackage: subPackage
  }), subPackage ? _react.default.createElement("div", {
    className: "organisation-details__sub-period"
  }, "".concat(getDate(subPackage.subStart), " - ").concat(getDate(subPackage.subEnd))) : null));
}

var _default = (0, _react.memo)(OrganisationDetails);

exports.default = _default;